import { useEffect, useRef } from 'react';
import { useAMap } from '../hooks/useAMap';

const MapComponent = ({ className = '' }) => {
    const { aMap, loading, error } = useAMap();
    const mapContainerRef = useRef(null);
    const mapInstanceRef = useRef(null);

    useEffect(() => {
        if (!aMap || !mapContainerRef.current) return;

        // 初始化地图
        const initMap = () => {
            if (mapInstanceRef.current) return;

            // 宁波市中心坐标: 经度121.55, 纬度29.88
            const ningboCenter = [121.634452, 29.877609];;

            mapInstanceRef.current = new aMap.Map(mapContainerRef.current, {
                zoom: 17, // 设置地图级别
                center: ningboCenter, // 设置地图中心点坐标
                mapStyle: 'amap://styles/normal' // 设置地图样式
            });

            // 添加标记点
            const marker = new aMap.Marker({
                position: ningboCenter,
                title: '识道宁波咨询管理有限公司',
                icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png'
            });

            marker.setMap(mapInstanceRef.current);

            // 添加信息窗口
            const infoWindowContent = `
        <div style="padding: 10px; min-width: 200px;">
          <h5 style="margin: 0 0 5px 0; ">识道宁波咨询管理有限公司</h5>
          <p style="margin: 5px 0; font-size: 14px;">宁波市鄞州区宁波软件园一期D座8F</p>
          <button id="navigateBtn" style="
            margin-top: 10px;
            padding: 6px 12px;
            background-color: #1e3a8a;
            color: white;
            border: none;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
          ">导航到这里</button>
        </div>
      `;

            const infoWindow = new aMap.InfoWindow({
                content: infoWindowContent,
                offset: new aMap.Pixel(0, -30)
            });

            // 鼠标点击标记点时打开信息窗口
            marker.on('click', () => {
                infoWindow.open(mapInstanceRef.current, marker.getPosition());

                // 确保DOM更新后再绑定事件
                setTimeout(() => {
                    const navigateBtn = document.getElementById('navigateBtn');
                    if (navigateBtn) {
                        navigateBtn.onclick = () => {
                            // 使用高德地图导航功能
                            const url = `https://uri.amap.com/navigation?to=${ningboCenter[0]},${ningboCenter[1]},识道宁波咨询管理有限公司`;
                            window.open(url, '_blank');
                        };
                    }
                }, 100);
            });
        };

        initMap();

        // 清理函数
        return () => {
            if (mapInstanceRef.current) {
                mapInstanceRef.current.destroy();
                mapInstanceRef.current = null;
            }
        };
    }, [aMap]);

    if (loading) {
        return (
            <div className={`bg-gray-100 rounded-xl aspect-video flex items-center justify-center ${className}`}>
                <div className="text-center text-gray-500">
                    <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary-600 mb-2"></div>
                    <p>地图加载中...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className={`bg-gray-100 rounded-xl aspect-video flex items-center justify-center ${className}`}>
                <div className="text-center text-gray-500">
                    <p>地图加载失败</p>
                    <p className="text-sm mt-2">请检查网络连接或联系管理员</p>
                </div>
            </div>
        );
    }

    return (
        <div
            ref={mapContainerRef}
            className={`rounded-xl overflow-hidden ${className}`}
            style={{ width: '100%', height: '100%' }}
        />
    );
};

export default MapComponent;